import {
  ArtikeldatenFile,
  BarcodeAndSonderpfand,
  CrateFile,
  JobForInstallation,
  Modification,
  ShapeFile,
} from '../../domain/DTO'
import React, { useContext } from 'react'
import { SelectedCountryContext } from '../../domain/SelectedCountryContext'
import { useRemoteData } from '../../lib/RemoteData'
import { API_HOST } from '../../lib'
import { JobHistoryTable } from '../../pages/installations/components/JobHistoryTable'
import {
  ArticleDataTableWrapper,
  BarcodeInstallationTableWrapper,
  CrateInstallationTableWrapper,
  ShapeInstallationTableWrapper,
} from './AssortmentDatabase'
import { useNavigate } from 'react-router'

type InstallationAssortmentDatabaseProps = {
  commonId: string
  installationId: string
  history: JobForInstallation[]
  serialNumber: string
  initialTab?: string
}

export const InstallationAssortmentDatabase = ({
  commonId,
  installationId,
  history,
  serialNumber,
  initialTab,
}: InstallationAssortmentDatabaseProps) => {
  const navigate = useNavigate()
  const { selectedCountry } = useContext(SelectedCountryContext)

  const { data: barcode } = useRemoteData<BarcodeAndSonderpfand>(`${API_HOST}/v1/assortment/${commonId}/BARCODE`)
  const { data: commonBarcode } = useRemoteData<Modification[]>(
    `${API_HOST}/v1/common/${commonId}/BARCODE/modifications`,
  )
  const { data: overrideBarcode, refresh: refreshBarcode } = useRemoteData<Modification[]>(
    `${API_HOST}/v1/installation/${installationId}/BARCODE/modifications`,
  )

  const { data: shape } = useRemoteData<ShapeFile>(`${API_HOST}/v1/assortment/${commonId}/SHAPE`)
  const { data: commonShape } = useRemoteData<Modification[]>(`${API_HOST}/v1/common/${commonId}/SHAPE/modifications`)
  const { data: overrideShape, refresh: refreshShape } = useRemoteData<Modification[]>(
    `${API_HOST}/v1/installation/${installationId}/SHAPE/modifications`,
  )

  const { data: crate } = useRemoteData<CrateFile>(`${API_HOST}/v1/assortment/${commonId}/CRATE`)
  const { data: commonCrate } = useRemoteData<Modification[]>(`${API_HOST}/v1/common/${commonId}/CRATE/modifications`)
  const { data: overrideCrate, refresh: refreshCrate } = useRemoteData<Modification[]>(
    `${API_HOST}/v1/installation/${installationId}/CRATE/modifications`,
  )

  const { data: artikeldaten } = useRemoteData<ArtikeldatenFile>(`${API_HOST}/v1/assortment/${commonId}/ARTIKELDATEN`)

  const availableTypes = [
    shape ? 'Shape' : '',
    barcode ? 'Barcode' : '',
    crate ? 'Crate' : '',
    selectedCountry === 'DE' && artikeldaten ? 'Artikeldaten' : '',
    'Job History',
  ].filter((t) => t !== '')

  const getTabFromParam = (param?: string) => {
    if (!param) return null
    return availableTypes.find((t) => t.toLowerCase() === param.toLowerCase())
  }

  const activeTab = getTabFromParam(initialTab) || availableTypes[0]

  return (
    <div>
      <div className="tabs w-full">
        {availableTypes.map((type) => {
          return (
            <button
              key={type}
              className={`tab ${activeTab === type ? 'active' : ''}`}
              onClick={() => {
                navigate(`/installation/${installationId}/${type.toLowerCase()}`)
              }}
            >
              {type}
            </button>
          )
        })}
      </div>
      {activeTab === 'Shape' && (
        <ShapeInstallationTableWrapper
          config={'Installation'}
          shape={shape}
          common={commonShape}
          override={overrideShape}
          installationId={installationId}
          refresh={refreshShape}
        />
      )}
      {activeTab === 'Barcode' && (
        <BarcodeInstallationTableWrapper
          config={'Installation'}
          barcode={barcode}
          common={commonBarcode}
          override={overrideBarcode}
          installationId={installationId}
          refresh={refreshBarcode}
        />
      )}
      {activeTab === 'Crate' && (
        <CrateInstallationTableWrapper
          config={'Installation'}
          crate={crate}
          common={commonCrate}
          override={overrideCrate}
          installationId={installationId}
          refresh={refreshCrate}
        />
      )}
      {activeTab === 'Artikeldaten' && <ArticleDataTableWrapper artikeldaten={artikeldaten} />}
      {activeTab === 'Job History' ? <JobHistoryTable history={history} serialNumber={serialNumber} /> : null}
    </div>
  )
}
